import type { FunctionComponent } from 'react';
import { Box, ContentBlock } from 'braid-design-system';
import PageError from 'src/components/common/Error/PageError';

import { useTranslations } from '@vocab/react';
import translations from './.vocab';

const ErrorPage: FunctionComponent = () => {
  const { t } = useTranslations(translations);
  return (
    <ContentBlock>
      <Box data-testid="error-page">
        <PageError
          message={t(
            'Something went wrong! Please try again or contact customer support.',
          )}
        />
      </Box>
    </ContentBlock>
  );
};

export default ErrorPage;
